import { useCurrentClub } from '@/hooks/use-current-club';

export function Logo() {
  const club = useCurrentClub();
  if (club.logo) {
    return <img src={club.logo} alt={club.name} className="w-24 h-auto" />;
  }
  return (
    <div>
      <span className="text-sm font-medium text-neutral-600">
        {club.name.charAt(0).toUpperCase()}
      </span>
    </div>
  );
}
